import { render, staticRenderFns } from "./Transaksi.vue?vue&type=template&id=3dd37b80&scoped=true"
import script from "./Transaksi.vue?vue&type=script&lang=js"
export * from "./Transaksi.vue?vue&type=script&lang=js"
import style0 from "./Transaksi.vue?vue&type=style&index=0&id=3dd37b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd37b80",
  null
  
)

export default component.exports